import axios from "axios";
const BASE_URL = process.env.REACT_APP_WEB_URL;


const axiosCilent = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `${sessionStorage.getItem("jwt")}`
  },
});

axiosCilent.defaults.timeout = 60000;

axiosCilent.interceptors.request.use(async (request) => {
  const jwt = sessionStorage.getItem("jwt");
  if (jwt && request?.headers) {
    request.headers.Authorization = jwt;
  }
  return {
    ...request,
  };
});

axiosCilent.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    throw err;
  }
);

export default axiosCilent;
